GP.models.User = Backbone.Model.extend({
    initialize: function(attributes, options) {
        // needed for custom funcs
        _.bindAll(this, 'url', 'thread_json');
    },
    idAttribute:'duid',
    defaults:{
        duid: null,
        username:null,
        age: null,
        city: null,
        online: false,
        country_code: null,
        discreet_profile: null,
        email_validated: null,
        gender: null,
        interested_in: null,
        membership: null,
        pic: null,
        pg_pic: null,
        seeking: null,
        state_code: null,
        pics: [],
        friendship:'decline',
        msg_approach_pref: '',
        has_access_private: false,
    },
    attr_types: {
        duid: 'int',
        age:  'int'
    },
    // override the "set" method for this model to ensure correct values types for attributes
    // matched in the attr_types object above
    set: function(attr, options) {
        if (typeof _gp_utils != 'undefined' && _gp_utils.bbm_ensure_types == 'function') {
            _gp_utils.bbm_ensure_types.apply(this, arguments);
        } else {
            Backbone.Model.prototype.set.apply(this, arguments);
        }
    },
    // could use $.proxy to return _gp_utils.bbm_ensure_types function with proper context
    // but would copy function for every model and most likely waste memory/cpu speed
    // set: $.proxy(_gp_utils.bbm_ensure_types, GP.models.Content),
    thread_json: function(done_cb, fail_cb) {
        var promise = $.get('/members/msg/get_thread_json/', { duid: this.get('duid') });
        if (GP.Util.check_callable(done_cb)) {
            promise.done(done_cb);
        }
        if (GP.Util.check_callable(fail_cb)) {
            promise.fail(fail_cb);
        }
        return promise;
    },
    url: function() {
        return '/members/user/profile/?duid='+this.get('duid');
    }
});
